import { render, staticRenderFns } from "./LoadClient.vue?vue&type=template&id=000f44b2"
import script from "./LoadClient.vue?vue&type=script&lang=js"
export * from "./LoadClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports